






























































































































































































































































































































































































































































































































import { Component, Vue,Prop,Watch } from "vue-property-decorator";
import Exhibition from '../components/exhibition.vue'
import { getQueryVariable,getCommonConfig, getCountryList, Country } from "@/services/api";
import { getCompanyInfo } from "@/model/CompanyInfo";
import { FormTargetingVO } from "@/model/FormWheel";
import { isEnableTargetBrower } from "@/utils/experiment";

@Component({
  components: {
    'yc-exhibition': Exhibition
  },
})
export default  class DispalyRules extends Vue  {
  @Prop(String)
  id?:string;

  @Prop(Object)
  rulesData!:any

  @Prop(Number)
  triggerEventType!:any

  @Prop(Object)
  targetingData!: FormTargetingVO

  @Prop(String)
  activeTag?:string;

  rules =  this.rulesData

  blankCloseArray = [30, 621, 907, 1333, 1334, 1379, 1738]

  targeting = this.targetingData
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;

  urls = true
  excludeUrls = false

  triggerFactor = ''
  // triggerCode = `<div class="cartx-popup-trigger cartx-popup-btn" data-id="${this.id || '发布后可见'}">Notify Me When Available</div>`;

  measureValue1:number =1
  measureValue2:number =1

  loadingCountDownOptions:number[] = []
  pageSlideOptions:number[] = [40, 50, 60, 70, 80, 90, 100]
  pageSlideUnit:object[] = [{
    name: '百分比',
    value: 'Percentage'
  }, {
    name: '像素',
    value: 'Pixel'
  }]

  completeMatchingUrls = true
  completeMatchingExcludeUrl = true


  targetUserOptions: any[] = [
      {
          "show": "等于",
          "en": "EQUAL",
          "associate": 0
      },
      {
          "show": "不等于",
          "en": "NOTEQUAL",
          "associate": 0
      },
      {
          "show": "大于",
          "en": "GT",
          "associate": 0
      },
      {
          "show": "大于等于",
          "en": "GTE",
          "associate": 0
      },
      {
          "show": "小于",
          "en": "LT",
          "associate": 0
      },
      {
          "show": "小于等于",
          "en": "LTE",
          "associate": 0
      },
      {
          "show": "区间",
          "en": "BETTEN",
          "associate": 0
      },
      {
          "show": "有值",
          "en": "HAS",
          "associate": 0
      },
      {
          "show": "没值",
          "en": "HASNOT",
          "associate": 0
      }
  ]
  displayFrequency: number= 24

  displayFrequencyValue = 'h'

  displayFrequencyOptions:any[] = [
    {label:'小时', value:"h"},
    {label:'分钟', value:"m"},
    {label:'秒', value:"s"},
  ]

  urlsArr = []
  excludeUrlsArr = []

  showPageCheckout = false;

  countryList: Country[] = [{
    countryAbbreviation: 'CN',
    country: 'China',
    countryName: '中国'
  }];

  get isAbtest() {
    return getQueryVariable('abtest') === 'true';
  }

  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  get enableMultipleLanguages() {
    return [30, 529].includes(getCompanyInfo().id as number);
  }

  get enableTargetBrower() {
    return isEnableTargetBrower() && [0].includes(this.triggerEventType);
  }

  get targetScript() {
    return this.id ? `<div id="cartx-form-${this.id}"></div>` : '保存后查看嵌入代码'
  }

  get customTargetScript() {
    return this.id ? `window.cartsee = window.cartsee || [];\n window.cartsee.push(['openForm', '${this.id}']);` : '保存后查看嵌入代码'
  }

  async getMask (){
    try {
      const result = await getCommonConfig('formClickBlankCloseStart');
      this.blankCloseArray = JSON.parse(result?.data?.data)
    } catch (e) {
      console.error('getCommonConfig formClickBlankCloseStart error', e);
    }
  }

  created() {
    this.loadingCountDownOptionsFun()
    this.displayFrequencyInit()
    this.triggerRules()
    this.getMask()
    if (this.enableMultipleLanguages) {
      this.getCountryList();
    }
  }

  async getCountryList() {
    try {
      const result = await getCountryList({});
      this.countryList = result.data.data;
    } catch (e: any) {
      if (e?.handled) {
        return;
      }
      this.$message.warning('获取国家列表失败!');
    }
  }

  copyCode(){
    const code = (document.getElementById('dispaly-rules-form-code') as HTMLTextAreaElement).value;
    navigator.clipboard.writeText(code);
    this.$message.success('复制成功');
  }

  mounted() {
    this.setInitData();
  }
  setInitData() {
    // 初始化浏览器选择字段，防止旧数据无字段时报错
    if (this.enableTargetBrower) {
      this.targeting.browers = this.targeting.browers || [];
      this.targeting.excludeBrowers = this.targeting.excludeBrowers || [];
    }

    if (
      this.targeting?.urls?.length > 0 ||
      this.targeting?.urlParts?.length > 0 ||
      this.targeting?.excludeUrls?.length > 0 ||
      this.targeting?.excludeUrlParts?.length > 0
    ) {
      this.showTargetUrl = true;
    }
    if (this.targeting.pages?.includes('1')) {
      this.selectList['1'] = true;
    }
    if (this.targeting.pages?.includes('2')) {
      this.selectList['2'] = true;
    }
    if (this.targeting.pages?.includes('3')) {
      this.selectList['3'] = true;
    }
    if (this.targeting.excludePages?.includes('4')) {
      this.selectList['4'] = true;
    }
    if (this.targeting.excludePages?.includes('5')) {
      this.selectList['5'] = true;
    }
    this.showPageCheckout = false;
    this.$nextTick(() => {
      this.showPageCheckout = true;
      this.$forceUpdate();
    });
  }
  messagetips(){
    this.$alert(`<p>支持输入域名、完整URL链接及URL后缀“/” </p>
      <p>支持使用“*”作为通配符 </p>
      <p style="font-weight: bold;">1、需要准确在某些页面打开弹窗时使用【等于】</p>
      <p>希望在首页展示弹窗，使用页面URL 等于【yourdomain.com/】；</p>
      <p>希望在collection页展示弹窗，使用页面URL等于【yourdomain.com/en-ja/collections/*】 collection页根据网站命名对应修改；</p>
      <p>希望在detail页展示弹窗，使用页面URL等于【yourdomain.com/en-ja/products/*】detail页根据网站命名对应修改；</p>
      <br/>
      <p style="font-weight: bold;">2、需要通过某个链接内带关键词就触发弹窗时使用【包含】</p>
      <p>希望在collection页展示弹窗，使用页面URL包含【collections/*】 collection页根据网站命名对应修改；</p>
      <p>希望在detail页展示弹窗，使用页面URL包含【products/*】detail页根据网站命名对应修改；</p>`,
     '提示', {
      confirmButtonText: '我知道了',
      dangerouslyUseHTMLString: true
    });
  }

  changeIncludeArea(val: any){
    if (!val) {
      this.rules.includeAreaList = [];
    }
  }

  changeExcludeArea(val: any){
    if (!val) {
      this.rules.excludeAreaList = [];
    }
  }

  displayFrequencyInit(){
    if (this.rules.displayFrequency > 60 * 60) {
      this.displayFrequency = this.rules.displayFrequency / 60 / 60
      this.displayFrequencyValue = "h"
    }else if (this.rules.displayFrequency > 60  ) {
      this.displayFrequency = this.rules.displayFrequency / 60
      this.displayFrequencyValue = "m"
    }else {
      this.displayFrequency = this.rules.displayFrequency
      this.displayFrequencyValue = "s"
    }
  }

  triggerRules(){
    if(this.rules?.loadingCountDownShow){
      this.triggerFactor = 'loadingCountDownShow'
    }else if(this.rules?.readyToLeave){
      this.triggerFactor = 'readyToLeave'
    }else if(this.rules?.readyToLeaveBate){
      this.triggerFactor = 'readyToLeaveBate'
    }else if(this.rules?.addPurchaseDownShow){
      this.triggerFactor = 'addPurchaseDownShow'
    }else if(this.rules?.couponLinkJump){
      this.triggerFactor = 'couponLinkJump'
    }else if(this.rules?.discardBillLeave){
      this.triggerFactor = 'discardBillLeave'
    }else if(this.rules?.loadingPageSlideShow){
      this.triggerFactor = 'loadingPageSlideShow'
    } else if (this.rules?.addPurchaseJumpPageShow) {
      this.triggerFactor = 'addPurchaseJumpPageShow';
    }

    //老数据兼容处理
    if(this.rules?.loadingCountDownShow && this.rules?.readyToLeave){
      this.triggerFactor = ''
    }

  }

  changeUrls({url , urlParts}:any){
    this.targeting.urls = url
    this.targeting.urlParts = urlParts
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }

  changeExcludeUrls({url , urlParts}:any){
    this.targeting.excludeUrls = url
    this.targeting.excludeUrlParts = urlParts
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }

  changeTargetingData(){
    this.$emit('changeTargetingData',this.targeting)
  }

  save(){
    if (this.valid()) {
      this.$emit('save')
    }
    window?.gtagClick('form_tool_enable','弹窗_启用订阅工具')
  }

  valid() {
    if (this.enableMultipleLanguages) {
      return this.targetingValid() && this.translateValid()
    } else {
      return this.targetingValid()
    }
  }

  saveDraft(){
    if (this.isAbtest) {
      if (!this.isEditAbTest) {
        return;
      }
    }
    if (this.valid()) {
      this.$emit('saveDraft')
    }
    window?.gtagClick('form_tool_save','弹窗_保存订阅工具')
  }

  backStep() {
    if (this.valid()) {
      this.$emit('backStep')
    }
  }

  cancel(){
    if (this.valid()) {
      this.$emit('cancel')
    }
  }

  translateValid() {
    if (this.rules.includeArea && this.rules.includeAreaList.length <= 0) {
      this.$message.warning('向特定位置的用户展示为空，请选择');
      return false
    }

    if (this.rules.excludeArea && this.rules.excludeAreaList.length <= 0) {
      this.$message.warning('不向特定位置的用户展示为空，请选择');
      return false
    }

    return true;
  }

  //校验
  targetingValid(){
    //在特定页面展示为空
    if (this.$refs.inPages && !this.$refs.inPages.valid() ) {
      return false
    }
    //不在特定页面展示
    if (this.$refs.noInPages && !this.$refs.noInPages.valid() ) {
      return false
    }

    //选择用户群校验
    if(!this.rules.subscribedSubscriber && !this.rules.unsubscribedSubscriber){
      this.$message.warning('请选择用户群')
      return false
    }

    //两个筛选条件不能存在相同的URL
    let includeUrls = this.targeting?.urls?.concat(this.targeting?.urlParts)
    let excludeUrls = this.targeting?.excludeUrls?.concat(this.targeting?.excludeUrlParts)
    let count = 0
    includeUrls?.forEach((includeItem) => {
      excludeUrls?.forEach((excludeItem) => {
        if(includeItem.url == excludeItem.url){
          count++
        }
      });
    });
    if(count != 0){
      this.$message.warning('URL不能相同')
      return false
    }

    if (!this.triggerFactor) {
      this.$message.warning('触发条件不能为空')
      return false
    }
    return true
  }

  //设置倒计时步长
  loadingCountDownOptionsFun(){
    let arr  = []
    for (let i = 0; i < 20; i++) {
      arr.push(i)
    }
    for (let i = 20; i <= 120; i=i+5) {
      arr.push(i)
    }
    this.loadingCountDownOptions = arr
  }

  changeDisplayFrequencyValue(){
    if (this.displayFrequencyValue === "h") {
      this.rules.displayFrequency = this.displayFrequency * 60 * 60
    }else if (this.displayFrequencyValue === "m") {
      this.rules.displayFrequency = this.displayFrequency * 60
    }else if (this.displayFrequencyValue === "s") {
      this.rules.displayFrequency = this.displayFrequency
    }
  }

  changeSubscribeRulesData(val){
    // console.log('changeSubscribeRulesData', val);
    this.rules.loadingCountDownShow = false
    this.rules.loadingPageSlideShow = false
    this.rules.readyToLeave = false
    this.rules.readyToLeaveBate = false
    this.rules.couponLinkJump = false
    this.rules.addPurchaseDownShow = false
    this.rules.addPurchaseJumpPageShow = false
    this.rules[val] = true
    this.$emit('changeRulesData',this.rules)
  }

  changeRulesData(){
    this.$emit('changeRulesData',this.rules)
  }
  changeRulesDataGa(){
    this.$emit('changeRulesData',this.rules)
    window?.gtagClick('form_edit_setCountdown','弹窗_编辑订阅工具_设置倒计时器')
  }

  changePixelValue(rules){
    if(isNaN(rules.loadingPageSlidePixel)){
      rules.loadingPageSlidePixel = 400
    }
  }

  changeSingleSubscribers(val){
    this.rules.subscribedSubscriber = false
    this.rules.unsubscribedSubscriber = false
    this.rules[val] = true
    this.$emit('changeRulesData',this.rules)
  }
  changeMultiSubscribers(){
    this.$emit('changeRulesData',this.rules)
    if(this.rules.clickBackgroundCloseOption){
      window?.gtagClick('form_edit_toggleClickClose','弹窗_编辑订阅工具_设置空白处点击关闭')
    }
  }


  @Watch('measureValue1')
  changeMeasureValue1(val:number){
    this.rules.measureValue = val + '-'+ this.measureValue2
    this.$emit('changeRulesData',this.rules)
  }

  @Watch('measureValue2')
  changeMeasureValue2(val:number){
    this.rules.measureValue = this.measureValue1 + '-'+ val
    this.$emit('changeRulesData',this.rules)
  }

  @Watch('rulesData')
  changerulesData(val:any){
    this.rules = val
    this.displayFrequencyInit()
    this.triggerRules()
  }

  @Watch('targetingData')
  changetargetingData(val:any){
    this.targeting = val
    if (val?.urls?.length > 0 || val?.urlParts?.length > 0 || val?.excludeUrls?.length > 0 || val?.excludeUrlParts?.length > 0) {
      this.showTargetUrl = true;
    }
    this.setInitData();
  }


  showTargetUrl = false;
  showTarget() {
    this.showTargetUrl = !this.showTargetUrl;
  }

  selectList = {
    "1":false,
    "2":false,
    "3":false,
    "4":false,
    "5":false,
  }

  targetIsChecked(pageId:any) {
    return this.targeting.pages?.includes(pageId);
  }
  targetChecked(checked:boolean, pageId:any) {
    this.targeting.pages = this.targeting.pages?.filter((oldId:any) => pageId != oldId) || [];
    if (checked) {
      this.targeting.pages.push(pageId);
    }
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }
  targetExcludeIsChecked(pageId:any) {
    return this.targeting.excludePages?.includes(pageId);
  }
  targetExcludeChecked(checked:boolean, pageId:any) {
    this.targeting.excludePages = this.targeting.excludePages?.filter((oldId:any) => pageId != oldId) || [];
    if (checked) {
      this.targeting.excludePages.push(pageId);
    }
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }

  browerIsChecked(browerId: string) {
    return this.targeting.browers?.includes(browerId);
  }

  browerChecked(checked: boolean, browerId: string) {
    this.targeting.browers = this.targeting.browers?.filter((oldId: string) => browerId !== oldId) || [];
    if (checked) {
      this.targeting.browers.push(browerId);
    }
    this.changeTargetingData();
  }

  browerExcludeIsChecked(browerId: string) {
    return this.targeting.excludeBrowers?.includes(browerId);
  }

  browerExcludeChecked(checked: boolean, browerId: string) {
    this.targeting.excludeBrowers = this.targeting.excludeBrowers?.filter((oldId: string) => browerId !== oldId) || [];
    if (checked) {
      this.targeting.excludeBrowers.push(browerId);
    }
    this.changeTargetingData();
  }
}
